<template>
    <div v-if="purchase.actions.supplier.supplementary_agreement === 'sign'">
        <fl44-contract-supplier-sign-supplementary-agreement-button :supplementary-agreement="supplementaryAgreement" :purchase="purchase" class="mb-3" @refresh="$emit('refresh')" />
        <template v-if="purchase.actions.supplier.can_store_supplementary_agreement_disagreement">
            <form-row-single-line-document-upload :label-cols-lg="3" title="Протокол разногласий" v-model="form.disagreement" :v="$v.form.disagreement" />
            <form-row-edit-textarea label="Комментарий" v-model.trim="form.comment" :v="$v.form.comment" />
            <b-overlay :show="isDataSending" opacity="0.6" rounded spinner-small spinner-variant="primary">
                <b-btn :disabled="!$store.getters.getCanSign || $v.$invalid" class="mr-2 mb-2" variant="custom-green" @click="showSignForm">Подписать и отправить протокол разногласий</b-btn>
            </b-overlay>
            <template v-if="!$store.getters.getCanSign">
                <div v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">
                    Для действия требуется загрузить/заменить МЧД на странице:
                    <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link>
                </div>
                <div v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подписание возможно только при авторизации при помощи ЭЦП</div>
            </template>

            <b-modal ref="sign-form-modal" v-model="showSignModal" centered no-close-on-backdrop no-close-on-esc scrollable size="lg" title="Подписать протокол разногласий" @close="cancelSignModal">
                <template #modal-header-close>
                    <button-close-modal />
                </template>
                <div class="d-block text-left">
                    <b-tabs content-class="mt-3 px-3">
                        <b-tab active>
                            <template #title>
                                <span class="system_link-style fs-16">Протокол разногласий</span>
                            </template>
                            <text-row-single-document compact :label-cols-lg="4" :label-cols-sm="4" label="Протокол разногласий" :value="form.disagreement" />
                            <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Комментарий" :value="form.comment" />
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <span class="system_link-style fs-16">XML</span>
                            </template>
                            <b-form-textarea v-if="!isSignedXml" v-model="formXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                            <b-form-textarea v-else v-model="signedFormXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                        </b-tab>
                    </b-tabs>
                </div>
                <div slot="modal-footer" class="w-100 px-3">
                    <text-row compact label="Сертификат" :value="certificate?.subjectName" />
                    <b-button :disabled="isDataSending" class="mr-2 text-uppercase" variant="custom-outline-secondary" @click="cancelSignModal">Отмена</b-button>
                    <b-overlay v-if="!isSignedXml" :show="isSigningXml" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                        <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="signForm">Подписать</b-button>
                    </b-overlay>
                    <b-overlay v-else :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                        <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="storeSignedDisagreement">Отправить</b-button>
                    </b-overlay>
                </div>
            </b-modal>
        </template>
    </div>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';
import { createMultipleSignatures, getCertificate } from 'crypto-pro';
import Fl44ContractSupplierSignSupplementaryAgreementButton from '@/components/products/fl44/partials/fl44-contract-supplier-sign-supplementary-agreement-button.vue';

export default {
    name: 'private-fl44-contract-supplementary-agreement-supplier-block',
    components: { Fl44ContractSupplierSignSupplementaryAgreementButton },
    props: {
        purchase: {
            type: Object,
            required: true
        },
        supplementaryAgreement: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showSignModal: false,
            isSigningXml: false,
            formXml: '',
            signedFormXml: null,
            signedAttachments: [],
            isSignedXml: false,
            isDataSending: false,
            certificate: null,
            form: {
                disagreement: null,
                comment: ''
            },
            signedDisagreement: null,
            fields: [
                { key: 'created_at', label: 'Дата и время', sortable: false, tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '200px', maxWidth: '200px' } },
                { key: 'contract_attachment', label: 'Документ', sortable: false, tdClass: 'align-text-top py-1', thClass: 'text-nowrap py-1' },
                { key: 'sign_customer', label: 'Подпись заказчика', sortable: false, tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '50px' } },
                { key: 'sign_supplier', label: 'Подпись поставщика', sortable: false, tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '50px' } }
            ]
        };
    },
    validations() {
        return {
            form: {
                disagreement: {
                    required
                },
                comment: {
                    required,
                    minLength: minLength(3)
                }
            }
        };
    },
    methods: {
        async showSignForm() {
            if (!this.$store.getters.getCanSign) {
                return;
            }
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            this.$api.personal.fl44.getSupplementaryAgreementDisagreementXML(this.purchase.id, this.form).then((resp) => {
                this.formXml = resp.xml;
                this.showSignModal = true;
            });
        },
        async signForm() {
            this.isSigningXml = true;
            const dataToSign = [
                {
                    method: 'xml',
                    value: this.formXml
                },
                {
                    method: 'detached',
                    value: this.form.disagreement.hash,
                    id: this.form.disagreement.id
                }
            ];
            const signedResult = await createMultipleSignatures(this.$store.getters.getCurrentThumbprint, dataToSign, true);
            this.signedFormXml = signedResult.find((item) => item.method === 'xml').result;
            this.signedDisagreement = signedResult.find((item) => item.method === 'detached' && item.value === this.form.disagreement.hash).result;
            this.isSignedXml = !!this.signedFormXml && this.signedDisagreement !== null;
            this.isSigningXml = false;
        },
        cancelSignModal() {
            this.showSignModal = false;
            this.isSignedXml = false;
            this.isSigningXml = false;
        },
        async storeSignedDisagreement() {
            this.isDataSending = true;
            const data = {
                certificate: await getCertificate(this.$store.getters.getCurrentThumbprint),
                xml: this.signedFormXml,
                comment: this.form.comment,
                disagreement: {
                    id: this.form.disagreement.id,
                    md5: this.signedDisagreement
                },
            };
            await this.$api.personal.fl44
                .storeSignedSupplementaryAgreementDisagreement(this.purchase.id, data, true)
                .then((result) => {
                    if (result) {
                        this.$emit('refresh');
                    }
                })
                .catch(() => {})
                .finally(() => {
                    this.isDataSending = false;
                });
        }
    }
};
</script>
